import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { space } from 'styled-system';
import { Link } from 'react-router-dom';

import { Select } from 'shared/components';

import {
  SettingsFieldContainer,
  SettingsFieldInputContainer,
  SettingsFieldLabel,
  SelectFieldWrapper,
} from 'src/dispensary-admin/settings/styles';

export function SelectField({ title, options, ...props }) {
  const baseTestId = props['data-testid'] || _.kebabCase(title) || 'select-field';
  const fieldContainerTestId = `${baseTestId}-field-container`;
  const inputContainerTestId = `${baseTestId}-input-container`;
  const wrapperTestId = `${baseTestId}-wrapper`;
  const selectId = props.id ?? `${baseTestId}-select`;

  return (
    <StyledSettingsFieldContainer noBottom mb='25px' data-testid={fieldContainerTestId}>
      <StyledSettingsFieldLabel as='label' htmlFor={selectId}>
        {title}
      </StyledSettingsFieldLabel>
      <StyledSettingsFieldInputContainer data-testid={inputContainerTestId}>
        <StyledSelectFieldWrapper data-testid={wrapperTestId}>
          <StyledSelect id={selectId} {...props}>
            {_.map(options, (option) => (
              <option key={option.key} value={option.value}>
                {option.label ?? option.value}
              </option>
            ))}
          </StyledSelect>
        </StyledSelectFieldWrapper>
      </StyledSettingsFieldInputContainer>
    </StyledSettingsFieldContainer>
  );
}

const StyledSettingsFieldContainer = styled(SettingsFieldContainer)`
  flex-direction: column;
  width: 100%;
`;

const StyledSettingsFieldLabel = styled(SettingsFieldLabel)`
  text-transform: uppercase;
  font-size: 11px;
  color: #969ea5;
  margin-bottom: 7px !important;
`;

const StyledSettingsFieldInputContainer = styled(SettingsFieldInputContainer)`
  width: 100%;
`;

const StyledSelectFieldWrapper = styled(SelectFieldWrapper)`
  width: 100%;
`;

const StyledSelect = styled(Select)`
  width: 100%;
  height: 47px;
  select {
    font-size: 13px !important;
  }
`;

export const StyledLink = styled(Link)`
  color: #0b99e6;
  font-size: 12px;
  display: inline-block;
  :hover {
    cursor: pointer;
  }
  ${space}
`;
